import RankOrderExportViewModel from "./RankOrderExportViewModel";
import RankOrderViewModel from "./RankOrderViewModel";
import TripRateCalculationFiltersViewModel from "./TripRateCalculationFiltersViewModel";
import { TimePair } from "../../Utilities/ViewModels/TimePair";

export default class RankOrderPDFViewModel {
    rankOrderVm: RankOrderViewModel = new RankOrderViewModel;
    filtersVm: TripRateCalculationFiltersViewModel = new TripRateCalculationFiltersViewModel;
    exportFiltersVm: RankOrderExportViewModel = new RankOrderExportViewModel;
    selectedSurveys: string[] = [];
    manuallyRemovedSurveysCount: number = 0;
    autoRemovedSurveysCountList: number = 0;
    hourly: boolean = false;
    startTime: number = 0;
    endTime: number = 0;
    selectedTimeFrames: TimePair[] = [];
    sortBy: string = "totals"
    addUserComments: boolean = false;
    explanatoryCommentsIncluded: boolean = false;
    userComments: string = '';
}